import { useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useShigoSession } from '../../lib/useShigoSession';

export function LogoutPage() {
  const navigate = useNavigate();
  const { clearSession } = useShigoSession();

  useEffect(() => {
    clearSession();
    void navigate({ to: '/login', replace: true });
  }, [clearSession, navigate]);

  return null;
}
